
import React from 'react';
import { preparePlayerConfig } from '../services/VideoPlayerService';
import { StyleSheet, css } from 'aphrodite/no-important';
import { reformatReleaseUrl } from '../../../assets/components/fsUtils/fsPlayerUtils';

class FsPlayer extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			playerConfig: this.props.playerConfig,
			isTopPinEnabled: true
		}
	}

	componentDidMount() {
	}

	componentWillUpdate() {
	}

	render(){

		let playerConfig = this.props.playerConfig
		//reformat url to jw player format
		if(document.body.classList.contains('jw-player')) {
			playerConfig.releaseURL = reformatReleaseUrl(playerConfig.releaseURL);
		}

		let pinClass = this.state.isTopPinEnabled ? 'pin-top' : '';
		if(playerConfig instanceof Object){
			playerConfig = preparePlayerConfig(playerConfig);
		}

		return (
			<div className="fs-player">
				<div className="fs-pin-wrapper">
					<div className="fs-pin-cont">
						<div className="fs-video-details"></div>
						<div className={"platformPlayer-wrapper " + pinClass}>
							<div ref={this.props.playerRef}
								className={css(styles.playerStyles) + " fs-video-player"}
								data-player-config={playerConfig}></div>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

export default FsPlayer;


const styles = StyleSheet.create({
	playerStyles: {
		height: 'auto !important',
		width: '100% !important',
		paddingBottom: '56% !important',
		position: 'absolute'
	}
});


// WEBPACK FOOTER //
// ./react-app-src/shared/components/FsPlayer.js